var _classCallCheck = require("/Users/leo/Sites/PV/othello-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/leo/Sites/PV/othello-app/node_modules/@babel/runtime/helpers/createClass");

var Store =
/*#__PURE__*/
function () {
  "use strict";

  /**
   *
   * @param {*} reducer
   */
  function Store(reducer) {
    _classCallCheck(this, Store);

    this._reducer = reducer;
    this._state = reducer();
  }
  /**
   *
   * @param {() => {gameState: string, board: number[][], placeableCells: {x: number, y: number}[]}} listener
   */


  _createClass(Store, [{
    key: "subscribe",
    value: function subscribe(listener) {
      this._listeners = this._listeners || [];

      this._listeners.push(listener);

      return this;
    }
    /**
     *
     * @param {{type: string, stone?: {x:numner, y: number, type: "white" | "black"}}} action
     */

  }, {
    key: "dispatch",
    value: function dispatch(action) {
      var _this = this;

      this._state = this._reducer(this._state, action);
      this._listeners && this._listeners.forEach(function (listener) {
        listener(_this._state);
      });
    }
    /**
     * @returns {{gameState: string, board: number[][], black: { placeableCells: {x: number, y: number}[], name: "black", timeLimit: number }, white: { placeableCells: {x: number, y: number}[], name: "white", timeLimit: number } }}
     */

  }, {
    key: "getState",
    value: function getState() {
      return this._state;
    }
  }]);

  return Store;
}();

module.exports = {
  Store: Store
};